/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CourseFeedback,
  CourseFeedbackCreateResult,
  CourseFeedbackInput,
  ListCourseFeedbacksParams,
  PaginatedCourseFeedbacks,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Course Feedback
 */
export const createCourseFeedback = (
    courseId: MaybeRefOrGetter<number>,
    courseFeedbackInput: MaybeRefOrGetter<CourseFeedbackInput>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);
courseFeedbackInput = toValue(courseFeedbackInput);

      return axiosClient<CourseFeedbackCreateResult>(
      {url: `/courses/${courseId}/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: courseFeedbackInput, signal
    },
      );
    }




export const getCreateCourseFeedbackMutationKey = () => ['createCourseFeedback'] as const;

export const getCreateCourseFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseFeedback>>, TError,CreateCourseFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCourseFeedback>>, TError,CreateCourseFeedbackMutationVariables, TContext> => {

const mutationKey = getCreateCourseFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourseFeedback>>, CreateCourseFeedbackMutationVariables> = (props) => {
          const {courseId,data} = props ?? {};

          return  createCourseFeedback(courseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createCourseFeedback>>>
    export type CreateCourseFeedbackMutationBody = CourseFeedbackInput
    export type CreateCourseFeedbackMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateCourseFeedbackMutationVariables = {courseId: number;data: CourseFeedbackInput}

    /**
 * @summary Create Course Feedback
 */
export const useCreateCourseFeedback = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseFeedback>>, TError,CreateCourseFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCourseFeedback>>,
        TError,
        CreateCourseFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCourseFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary List Course Feedbacks
 */
export const listCourseFeedbacks = (
    courseId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListCourseFeedbacksParams>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);
params = toValue(params);

      return axiosClient<PaginatedCourseFeedbacks>(
      {url: `/courses/${courseId}/feedbacks`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCourseFeedbacksQueryKey = (courseId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListCourseFeedbacksParams>,) => {
    return [
    'courses',courseId,'feedbacks', ...(params ? [params] : [])
    ] as const;
    }


export const getListCourseFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof listCourseFeedbacks>>, TError = ErrorType<SchemaValidationErrorResponse>>(courseId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListCourseFeedbacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCourseFeedbacksQueryKey(courseId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourseFeedbacks>>> = ({ signal }) => listCourseFeedbacks(courseId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(courseId) !== null && toValue(courseId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourseFeedbacks>>, TError, TData>
}

export type ListCourseFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof listCourseFeedbacks>>>
export type ListCourseFeedbacksQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List Course Feedbacks
 */

export function useListCourseFeedbacks<TData = Awaited<ReturnType<typeof listCourseFeedbacks>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 courseId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListCourseFeedbacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseFeedbacks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCourseFeedbacksQueryOptions(courseId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get a featured Course Feedback
 */
export const getFeaturedCourseFeedback = (
    courseId: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);

      return axiosClient<CourseFeedback>(
      {url: `/courses/${courseId}/feedbacks/featured`, method: 'GET', signal
    },
      );
    }




export const getGetFeaturedCourseFeedbackQueryKey = (courseId: MaybeRefOrGetter<number>,) => {
    return [
    'courses',courseId,'feedbacks','featured'
    ] as const;
    }


export const getGetFeaturedCourseFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(courseId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetFeaturedCourseFeedbackQueryKey(courseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>> = ({ signal }) => getFeaturedCourseFeedback(courseId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(courseId) !== null && toValue(courseId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError, TData>
}

export type GetFeaturedCourseFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>>
export type GetFeaturedCourseFeedbackQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get a featured Course Feedback
 */

export function useGetFeaturedCourseFeedback<TData = Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 courseId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeaturedCourseFeedbackQueryOptions(courseId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get a Course Feedback
 */
export const getCourseFeedback = (
    courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);
id = toValue(id);

      return axiosClient<CourseFeedback>(
      {url: `/courses/${courseId}/feedbacks/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCourseFeedbackQueryKey = (courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>,) => {
    return [
    'courses',courseId,'feedbacks',id
    ] as const;
    }


export const getGetCourseFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getCourseFeedback>>, TError = ErrorType<SchemaValidationErrorResponse>>(courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCourseFeedbackQueryKey(courseId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseFeedback>>> = ({ signal }) => getCourseFeedback(courseId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(courseId) !== null && toValue(courseId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseFeedback>>, TError, TData>
}

export type GetCourseFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseFeedback>>>
export type GetCourseFeedbackQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get a Course Feedback
 */

export function useGetCourseFeedback<TData = Awaited<ReturnType<typeof getCourseFeedback>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseFeedback>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseFeedbackQueryOptions(courseId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






